import {useHomeworkManager} from "../../../hooks/useHomeworkManager";
import {useExamManager} from "../../../hooks/useExamManager";
import {useReminderManager} from "../../../hooks/useReminderManager";
import {useSubjectManager} from "../../../hooks/useSubjectManager";

export const useTaskManager = (selectedPlannerId: string) => {
    const {homework, toggleHomeworkCompletedOn, deleteHomework} = useHomeworkManager({plannerId: selectedPlannerId});
    const {exams, deleteExam} = useExamManager({plannerId: selectedPlannerId})
    const {reminders, toggleReminderCompletedOn, deleteReminder} = useReminderManager({plannerId: selectedPlannerId})
    const {subjects} = useSubjectManager({plannerId: selectedPlannerId})

    const homeworkByDate = homework.reduce((map, homework) => {
        if (homework?.date) {
            map[homework.date] = map[homework.date] || [];
            map[homework.date].push(homework);
            return map;
        } else {
            return [];
        }
    }, Object.create(null));

    const examsByDate = exams.reduce((map, exam) => {
        if (exam?.date) {
            map[exam.date] = map[exam.date] || [];
            map[exam.date].push(exam);
            return map;
        } else {
            return [];
        }
    }, Object.create(null));

    const remindersByDate = reminders.reduce((map, reminder) => {
        if (reminder?.date) {
            map[reminder.date] = map[reminder.date] || [];
            map[reminder.date].push(reminder);
            return map;
        } else {
            return [];
        }
    }, Object.create(null));

    return {
        homeworkByPlanner: homework,
        examsByPlanner: exams,
        remindersByPlanner: reminders,
        subjectsByPlanner: subjects,
        homeworkByDate,
        examsByDate,
        remindersByDate,
        toggleHomeworkCompletedOn,
        deleteHomework,
        deleteExam,
        toggleReminderCompletedOn,
        deleteReminder
    }
}